import React, { useState } from 'react';
import xmlFormatter from 'xml-formatter';
import CodeMirror from "@uiw/react-codemirror";

const XmlFormatter = () => {
    const [xmlData, setXmlData] = useState('');
    const [error, setError] = useState(null);

    const formatXml = () => {
        try {
            const formatted = xmlFormatter(xmlData, { collapseContent: true });
            setXmlData(formatted);
            setError(null);
        } catch (error) {
            setXmlData(xmlData);
            setError(`Error formatting XML. ${error.message}`);
        }
    };

    const resetForm = () => {
        setXmlData('');
        setError(null);
    };

    return (
        <main>
            <div className="container mt-4">
                {/* Section for Page Header */}
                <section aria-labelledby="xml-formatter-header">
                    <h2 id="xml-formatter-header" className="mb-3">XML Formatter</h2>
                </section>

                {/* Section for Input */}
                <section aria-labelledby="xml-input-header">
                    <h3 id="xml-input-header" className="mt-4 mb-3">Input</h3>
                    <div className="mt-4" role="group" aria-labelledby="xml-input-header">
                        <CodeMirror
                            value={xmlData}
                            onChange={(value) => setXmlData(value)}
                            placeholder="Enter XML here"
                            height="50vh"
                            basicSetup={{
                                foldGutter: false,
                                dropCursor: false,
                                allowMultipleSelections: false,
                                indentOnInput: false
                            }}
                        />
                    </div>
                </section>


                {/* Section for Actions */}
                <section aria-labelledby="xml-actions-header">
                    <h3 id="xml-actions-header" className="mt-4 mb-3">Actions</h3>
                    <div className="mt-2">
                        <button
                            type="button"
                            className="btn btn-secondary mt-2 ms-1"
                            onClick={formatXml}
                        >
                            Format XML
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary mt-2 ms-1"
                            onClick={resetForm}
                        >
                            Reset
                        </button>
                    </div>
                </section>

                {/* Section for Error Output */}
                {error && (
                    <section aria-labelledby="xml-error-header">
                        <h4 id="xml-error-header" className="mb-3 visually-hidden">Error</h4>
                        <div className="alert alert-danger mt-2" role="alert">
                            {error}
                        </div>
                    </section>
                )}
            </div>
        </main>
    );
};

export default XmlFormatter;
